/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ProviderStateEnum = (typeof ProviderStateEnum)[keyof typeof ProviderStateEnum];

export const ProviderStateEnum = {
  provider: 'provider',
  training_only_provider: 'training_only_provider',
  applicant: 'applicant',
  applicant_with_services_selected: 'applicant_with_services_selected',
  self_deactivated: 'self_deactivated',
  admin_deactivated: 'admin_deactivated',
} as const;
